import Vue from 'vue'
import Vuex from 'vuex'

import App from './App.vue'
import './registerServiceWorker'
import Icon from "./plugins/Icon.vue"

import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'

import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';

import GetTextPlugin from 'vue-gettext'

Vue.use(VueObserveVisibility);
Vue.use(GetTextPlugin, {translations: {}})
Vue.use(Vuex);
Vue.use(Vue2TouchEvents,
  {
    tapTolerance: 20
  })

Vue.config.productionTip = false
Vue.component("icon", Icon);


/* global WF_MAP_TYPE WayfinderAPI wayfinder*/
const store = new Vuex.Store({
  state: {
    count: 0,
    appName: "Wayfinder Vue Components",
    currentPOI: false,
		currentTab: 'groups',
    currentGroup: false,
  },
  mutations: {
    showCount(state) {
      console.log(state.count)
    },
    currentTab (state, tab) {
      state.currentTab = tab;
    }
  }
})

/* global WF_MAP_TYPE */

function loadScript(url, callback) {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(s);
  if (typeof callback == "function") {
    s.onload = callback;
    s.src = url;
  }
}

function loadVue () {
  Vue.prototype.$WF_MAP_TYPE = WF_MAP_TYPE;
  new Vue({
    store,
    render: h => h(App),
    created () {
      Vue.use(WayfinderVueComponents, this.$store) // Create it by passing in the store you want to use
    }
  }).$mount('#app')
}
function load3D () {
  loadScript("//static.3dwayfinder.com/shared/js/minified/frak-stable.min.js", function () {
    loadScript("//static.3dwayfinder.com/js/dist/3d/latest/Wayfinder3D.debug.js", function () {
      loadVue();
    });
  });
}

function load2D () {
	loadScript("./js/Wayfinder2D.debug.js", function () {
  	loadVue();
	});
}

let WF_MAP_TYPE = "3d";

if(location && location.search) {
	var options = unescape(location.search.substring(1));
	if (options.indexOf("mobile=") > -1) {

		WF_MAP_TYPE = "2d";
		load2D();
	} else if (WF_MAP_TYPE == "2d") {
		load2D();
	}
  else {
    load3D();
  }
} else {
  console.log("location.search", typeof WF_MAP_TYPE == "undefined", WF_MAP_TYPE)
	if (typeof WF_MAP_TYPE == "undefined" ||  WF_MAP_TYPE == "3d") {
		load3D();
	} else {
		load2D();
	}
}


